import React from 'react';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme as useMuiTheme, alpha } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function ModeFab({ copyMode, moveMode, onExitCopy, onExitMove }) {
  const theme = useMuiTheme();
  const isDark = theme.palette.mode === 'dark';

  const active = copyMode || moveMode;
  if (!active) return null;

  const tone = copyMode ? '#f59e0b' : '#16a34a';
  const icon = copyMode ? 'content_copy' : 'open_with';
  const title = copyMode ? 'Kopyalama modu' : 'Taşıma modu';
  const hint = copyMode ? 'Seans seç' : 'Hedef slota dokun';

  const onExit = () => {
    if (copyMode) onExitCopy?.();
    if (moveMode) onExitMove?.();
  };

  return (
    <MDBox
      sx={{
        position: 'fixed',
        left: 16,
        bottom: 16,
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.2,
        py: 0.9,
        borderRadius: '999px',
        background: isDark ? 'rgba(15,23,42,0.92)' : 'rgba(255,255,255,0.92)',
        border: `1px solid ${alpha(tone, isDark ? 0.45 : 0.35)}`,
        boxShadow: `0 16px 40px ${alpha('#000', isDark ? 0.45 : 0.18)}`,
        backdropFilter: 'blur(10px)',
      }}
    >
      <MDBox
        sx={{
          width: 34,
          height: 34,
          borderRadius: '999px',
          display: 'grid',
          placeItems: 'center',
          background: alpha(tone, isDark ? 0.25 : 0.16),
          border: `1px solid ${alpha(tone, isDark ? 0.55 : 0.35)}`,
        }}
      >
        <Icon sx={{ fontSize: 18, color: tone }}>{icon}</Icon>
      </MDBox>

      <MDBox sx={{ lineHeight: 1.1 }}>
        <MDTypography sx={{ fontSize: 12.5, fontWeight: 900 }}>{title}</MDTypography>
        <MDTypography sx={{ fontSize: 11.5, fontWeight: 700, opacity: 0.8 }}>{hint}</MDTypography>
      </MDBox>

      <Tooltip title="Modu kapat" arrow>
        <IconButton
          size="small"
          onClick={onExit}
          sx={{
            ml: 0.3,
            width: 34,
            height: 34,
            borderRadius: '999px',
            background: alpha('#ef4444', isDark ? 0.18 : 0.1),
            border: `1px solid ${alpha('#ef4444', isDark ? 0.35 : 0.22)}`,
            '&:hover': {
              background: alpha('#ef4444', isDark ? 0.28 : 0.16),
            },
          }}
        >
          <Icon sx={{ fontSize: 18, color: '#ef4444' }}>close</Icon>
        </IconButton>
      </Tooltip>
    </MDBox>
  );
}
